import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Library, OPTIONS } from '../library';

@Injectable({
  providedIn: 'root'
})
export class ImportDataService {

  constructor(private http: HttpClient) { }

  insertChargeDetailsFromCSV(chargeDetails: any): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `import/insert_charge_details_csv`, chargeDetails, OPTIONS);
  }

  insertScaleDetailsFromCSV(scaleDetails: any): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `import/insert_scale_details_csv`, scaleDetails, OPTIONS);
  }

  insertScalelineDetailsFromCSV(scalelineDetails: any): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `import/insert_scaleline_details_csv`, scalelineDetails, OPTIONS);
  }

  insertCategoryDetailsFromCSV(categoryDetails: any): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `import/insert_category_details_csv`, categoryDetails, OPTIONS);
  }

  insertCatalogDetailsFromCSV(catalogDetails: any): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `import/insert_catalog_details_csv`, catalogDetails, OPTIONS);
  }

  insertDepartmentDetailsFromCSV(depDetails: any): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `import/insert_department_details_csv`, depDetails, OPTIONS);
  }

  insertBranchDetailsFromCSV(branchDetails: any): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `import/insert_branch_details_csv`, branchDetails, OPTIONS);
  }

  insertJobDetailsFromCSV(branchDetails: any): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `import/insert_job_details_csv`, branchDetails, OPTIONS);
  }

  insertTimeEntriesFromCSV(timeEntries: any[]): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `import/insert_time_entries_csv`, timeEntries, OPTIONS);
  }

  insertHolidayDetailsFromCSV(holidayDetails: any): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `import/insert_holiday_details_csv`, holidayDetails, OPTIONS);
  }

  insertDefinitionConceptDetailsFromCSV(conceptDetails: any): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `import/insert_definitionConcept_details_csv`, conceptDetails, OPTIONS);
  }

  insertConfigDetailsFromCSV(configDetails: any): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `import/insert_config_details_csv`, configDetails, OPTIONS);
  }

  insertElementDetailsFromCSV(configDetails: any): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `import/insert_element_details_csv`, configDetails, OPTIONS);
  }

  insertElementValueDetailsFromCSV(configDetails: any): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `import/insert_elementValue_details_csv`, configDetails, OPTIONS);
  }

  insertDefaultScheduleFromCSV(scheduleDetails: any): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `import/insert_defautlt_schedule_csv`, scheduleDetails, OPTIONS);
  }

  insertDefaultScheduleLineFromCSV(scheduleLineDetails: any): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `import/insert_default_scheduleline_csv`, scheduleLineDetails, OPTIONS);
  }

  insertDeductionDetailsFromCSV(deductionDetails: any): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `import/insert_deduction_details_csv`, deductionDetails, OPTIONS);
  }

  insertAdjustmentDetailsFromCSV(adjustmentDetails: any): Observable<any> {
    return this.http.post<any>(Library.API_ENDPOINT + `import/insert_adjustment_details_csv`, adjustmentDetails, OPTIONS);
  }
}
